export enum LocalRouteNames {
  Home = 'index',
  MyProfile = 'my-account',
  MyAddresses = 'my-addresses',
  LoyaltyCard = 'my-account-loyalty-card',
  OrderHistory = 'my-account-order-history',
  OrderDetails = 'my-account-order-history-index',
  Wishlist = 'my-account-wishlist',
  RecipeWishlist = 'my-account-notebook',
  RecipeWishlistDetails = 'my-account-notebook-details-slug',
  Invoice = 'my-account-invoice',
  Checkout = 'checkout',
  ThankYou = 'legacy-ThankYou',
  ResetPassword = 'legacy-ResetPassword',
  SearchResults = 'search-term',
  FAQ = 'legacy-FAQ',
  AllOurProducts = 'legacy-AllProducts',
}

export enum ContentfulRouteNames {
  Basic = 'legacy-Basic-slug',
  AdviceListing = 'pages-slug',
  Advice = 'page-slug',
  Category = 'legacy-GenericCategory-GenericCategory',
  RecipeListing = 'recipes-slug',
  Recipe = 'legacy-Recipe-slug',
  ProductCategory = 'products-slug',
}

export const PAGE_TYPES_TO_ROUTES = {
  pageRecipe: ContentfulRouteNames.Recipe,
  pageRecipeList: ContentfulRouteNames.RecipeListing,
  pageAdviceListing: ContentfulRouteNames.AdviceListing,
};

export const DEFAULT_EODP_FR_URL_PARAMETER = '?page=library';
export const DEFAULT_EODP_FR_URL_PARAMETER_VALUE = 'library';
